export enum MoreActionsKeyHash {
  CloneTask = 'CLONE_TASK',
  MarkAtRisk = 'MARK_AT_RISK',
  RequestApproval = 'REQUEST_APPROVAL',
  MakeDependent = 'MAKE_DEPENDENT',
  ConvertToMilestone = 'CONVERT_TO_MILESTONE',
  Delete = 'DELETE',
  ChangePrivacy = 'CHANGE_PRIVACY',
  CreateJiraIssue = 'CREATE_JIRA_ISSUE',
  LinkJiraIssue = 'LINK_JIRA_ISSUE',
}
